import Painel from "views/Pages/Painel.jsx";
import Utilizadores from "views/Pages/Utilizadores.jsx";
import Cursos from "views/Pages/Cursos.jsx";
import PaginaCurso from "views/Pages/PaginaCurso";
import FormacaoContinua from "views/Pages/FormacaoContinua.jsx";
import PaginaFormacao from "views/Pages/PaginaFormacao";
import PaginaModelo from "views/Pages/PaginaModelo.jsx";
import PreencherFeedback from "views/Pages/PreencherFeedback.jsx";
import PaginaPercurso from "views/Pages/PaginaPercurso";
import Percursos from "views/Pages/Percursos.jsx";
import Mensagens from "views/Pages/Mensagens.jsx";
import Modelos from "views/Pages/Modelos.jsx";
import Catalogo from "views/Pages/Catalogo.jsx";
import BaseDashboard from "views/Pages/BaseDashboard.jsx";
import FormacoesUtilizador from "views/Pages/FormacoesUtilizador.jsx";
import Pagamentos from "../views/Pages/Pagamentos";
import ImportacaoHistorico from "../views/Pages/ImportacaoHistorico";
import {AllInclusive, Check, Dashboard as DashboardIcon, Email, FilterNone, HelpOutline, ImportExport, LibraryBooks, List, People, PeopleOutline, Receipt, Settings, Style, Subject} from "@material-ui/icons";
import ImportacaoHistoricoDetalhes from "../views/Pages/ImportacaoHistoricoDetalhes";
import general from "../general";
import PaginaFormulario from "../views/Pages/PaginaFormulario";
import Investiduras from "../views/Pages/Investiduras";
import Gestao from "../views/Pages/Gestao";
import Contactos from "../views/Pages/Contactos"
import FAQ from "../views/Pages/FAQ";

let permissoes = [];
let routes = null;

let _show = (menu_item) => {
  return !permissoes.length || permissoes.includes(menu_item);
};

let getDashRoutes = () => {
  if (window.App && window.App.state.user && window.App.state.user.permissoes) {
    let _permissoes = [];
    window.App.state.user.permissoes.forEach((perm) => {
      perm.operacoes.forEach((op) => {
        _permissoes.push(perm.modulo + "." + op);
      });
    });
    if (JSON.stringify(_permissoes) === JSON.stringify(permissoes) && routes !== null) {
      return routes;
    }
    permissoes = _permissoes;
  }

  routes = [];

  routes.push({
    path: "/dashboard",
    name: "Painel",
    icon: DashboardIcon,
    component: Painel
  });

  if (_show("formando.ler") || _show("utilizador.outros"))
    routes.push({
      collapse: true,
      state: "openUtilizadores",
      path: "/utilizadores",
      name: "Utilizadores",
      icon: People,
      views: [
        {
          path: "/adultos",
          name: "Adultos",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("formando.ler")
        },
        {
          path: "/outros-utilizadores",
          name: "Outros",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.outros")
        },
        {
          path: "/secretarios-regionais",
          name: "Secretários Regionais",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.secretarios_regionais")
        },
        {
          path: "/secretarios-nucleo",
          name: "Secretários de Núcleo",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.secretarios_nucleo")
        },
        {
          path: "/tutores-locais",
          name: "Tutores Locais",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.tutores_locais")
        },
        {
          path: "/cargos_temporarios",
          name: "Cargos Temporários",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.cargos_temporarios")
        },
        {
          path: "/tutorandos",
          name: "Tutorandos",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.ler_progresso_tutorando")
        },
        {
          path: "/utilizadores_em_percurso",
          name: "Adultos em Percurso",
          icon: PeopleOutline,
          component: Utilizadores,
          show: _show("utilizador.ler_progresso_agrupamento")
        },
      ].filter((item) => item.show)
    });

  // O correio é pessoal: fica escondido enquanto se age em nome de outro utilizador
  if (!(window.App && window.App.state.user && window.App.state.user.is_impersonating))
    routes.push({
      path: "/mensagens",
      name: "Mensagens",
      icon: Email,
      component: Mensagens
    });

  if (_show("formacao.ler_ff"))
    routes.push({
      path: "/modulos",
      name: "Módulos",
      icon: List,
      component: FormacoesUtilizador,
    });

  if (_show("modelo.editar"))
    routes.push({
      path: "/modelos",
      name: "Modelos",
      icon: Style,
      component: Modelos,
    });

  if (_show("modulo.ler"))
    routes.push({
      path: "/catalogo",
      name: "Catálogo",
      icon: Subject,
      component: Catalogo,
    });

  if (_show("curso.ler"))
    routes.push({
      path: "/cursos",
      name: "Cursos",
      icon: LibraryBooks,
      component: Cursos,
    });

  if (_show("percurso.editar") || general.userHasType("diretor_adj_percurso", "analista_percurso", "secretario_nucleo", "tutor_nucleo", "chefe_regional", "chefe_nucleo", "chefe_nacional"))
    routes.push({
      path: "/percursos",
      name: "Percursos",
      icon: FilterNone,
      component: Percursos,
    });

  routes.push({
    path: "/formacao_continua",
    name: "Form. Contínua",
    icon: AllInclusive,
    component: FormacaoContinua,
  });

  routes.push({
    path: "/pagamentos",
    name: "Pagamentos",
    icon: Receipt,
    component: Pagamentos
  });

  if (_show("submissao.gerir_investiduras"))
    routes.push({
      path: "/investiduras",
      name: "Investiduras",
      icon: Check,
      component: Investiduras
    });

  if (_show("administracao.importar_historico")) {
    routes.push({
        path: "/importacao_historico/:id",
        name: "Importação",
        component: ImportacaoHistoricoDetalhes,
        hidden: true
      },
      {
        path: "/importacao_historico",
        name: "Importação",
        icon: ImportExport,
        component: ImportacaoHistorico,
      })
  }

  if (_show("pagamento.ler_gestao"))
    routes.push({
      path: "/gestao",
      name: "Gestão",
      icon: Settings,
      component: Gestao
    });

  routes.push({
    path: "/faq",
    name: "Ajuda",
    icon: HelpOutline,
    component: FAQ
  });

  routes.push(
    {path: "/user-page", name: "Perfil", component: BaseDashboard, hidden: true},
    {path: "/perfil", name: "Perfil", component: BaseDashboard, hidden: true},
    {path: "/curso", name: "Curso", component: PaginaCurso, hidden: true},
    {path: "/formacao", name: "Formação", component: PaginaFormacao, hidden: true},
    {path: "/modelo", name: "Modelo", component: PaginaModelo, hidden: true},
    {path: "/percurso", name: "Percurso", component: PaginaPercurso, hidden: true},
    {path: "/feedback", name: "Percurso", component: PreencherFeedback, hidden: true},
    {path: "/formulario/:tipo", component: PaginaFormulario, hidden: true},
    {path: "/contactos", component: Contactos, name: "Contactos", hidden: true},
    {redirect: true, path: "/", pathTo: "/dashboard", name: "Dashboard"}
  );

  return routes;
}

export default getDashRoutes;
